import contractList, { ContractsListParams } from "@/getinfo-api/contracts";
import api from "@/getinfo-api";
import { MainList } from "@/classes/MainList";

export class ContractsListClass extends MainList {
  params: ContractsListParams = {
    companyId: this.companyId,
    limit: 30,
    offset: 0,
    sort: "createdAt",
    order: "DESC"
  };

  constructor(params?: any, selectedValue?: string | undefined) {
    super();
    this.method = contractList;
    this.params = { ...this.params, ...params };
    this.baseParams = this.params;
    if (selectedValue) {
      this.singleMethod = () => api.ContractApi.get(selectedValue);
      this.single();
    }
    this.list();
  }

  get contracts() {
    return this.listItems;
  }

  search(value: string) {
    this.params.number = value;
    this.params.offset = 0;
    this.listItems = [];
    this.list();
  }
}
